import PopupTemplate from "@arcgis/core/PopupTemplate";
import ActionButton from "@arcgis/core/support/actions/ActionButton.js";
import { TranslateService } from '@ngx-translate/core';

const heritageSitesimagem = "https://gis.israntique.org.il/webapp/mediaViewer/menoram.png"

// Function to create the heritage sites popup template with translation support
export function createHeritageSitesPopupTemplate(translate: TranslateService): PopupTemplate {
  const heritageSitesWebsiteatarmenora = new ActionButton({
    title: translate.instant('iaa.map.popup.heritageSite.websitePage'),
    id: "urlatarinmenora",
    image: heritageSitesimagem
  });

  return new PopupTemplate({
    title: translate.instant('iaa.map.popup.heritageSite.title'),
    actions: [heritageSitesWebsiteatarmenora],
    content: [{
      type: "fields",
      fieldInfos: [
        {
          label: translate.instant('iaa.map.popup.heritageSite.heritageSiteName') + ": ",
          fieldName: "ASSET_ENG_NAME",
          visible: true
        },
        {
          label: translate.instant('iaa.map.popup.heritageSite.siteAdditionDate') + ": ",
          fieldName: "CREATED_DATE",
          visible: true
        },
        {
          label: translate.instant('iaa.map.popup.heritageSite.siteAddingUser') + ": ",
          fieldName: "CREATED_USER",
          visible: true
        },
        {
          label: translate.instant('iaa.map.popup.heritageSite.spatialCharacterization') + ": ",
          fieldName: "SPATIAL_REL",
          visible: true
        },
        {
          label: translate.instant('iaa.map.popup.heritageSite.conservationStatus') + ": ",
          fieldName: "ASSET_CONSERVATION_STAT",
          visible: true
        },
        {
          label: translate.instant('iaa.map.popup.heritageSite.notes') + ": ",
          fieldName: "REMARKS",
          visible: true
        },
        {
          label: translate.instant('iaa.map.popup.heritageSite.polygonSource') + ": ",
          fieldName: "PROJ_ID",
          visible: true
        },
      ]
    }]
  });
}

// Legacy export for backward compatibility - will be deprecated
export const peilutIaaHeritageSitesPopupTemplate = {
  title: "שכבת רשת מתחמי עתיקות ומורשת - אתר ארכיאולוגי {ASSET_NAME}",
  content: [{
    type: "fields",
    fieldInfos: [
      {
        label: "שם מתחם עתיקות ומורשת באנגלית: ",
        fieldName: "ASSET_ENG_NAME",
        visible: true
      },
      {
        label: " תאריך הוספת האתר: ",
        fieldName: "CREATED_DATE",
        visible: true
      },
      {
        label: " משתמש מוסיף האתר: ",
        fieldName: "CREATED_USER",
        visible: true
      },
      {
        label: "איפיון מרחבי : ",
        fieldName: "SPATIAL_REL",
        visible: true
      },
      {
        label: "סטטוס שימור : ",
        fieldName: "ASSET_CONSERVATION_STAT",
        visible: true
      },
      {
        label: "הערות : ",
        fieldName: "REMARKS",
        visible: true
      },
      {
        label: "מקור הוספת הפוליגון: ",
        fieldName: "PROJ_ID",
        visible: true
      },
    ]
  }]
};